




















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import symbol from "@/components/Subject/symbol";

@Component
export default class SubjectMore extends Vue {
    @Prop({ required: true })
    subject!: Subject.Subject;

    subjectCopy = this.subject;
    symbolList = symbol.list;
    assistVal: string[] = [];
    assists = ["项目", "客户", "供应商", "部门", "员工", "存货"];

    created() {
        if (this.subject.dimAccountType !== null) this.assistVal = (<string>this.subject.dimAccountType).split(",");
    }
    changeAssist() {
        this.subjectCopy.dimAccountType = this.assistVal.join(",");
    }
    close() {
        this.$emit("close");
    }
    confirm() {
        // this.$emit("update:subject", this.subjectCopy);
        this.$emit("confirm", this.subjectCopy);
    }
}
